import { render } from "./joinActive.vue?vue&type=template&id=0f1b0a56&scoped=true"
import script from "./joinActive.vue?vue&type=script&lang=js"
export * from "./joinActive.vue?vue&type=script&lang=js"

import "./joinActive.vue?vue&type=style&index=0&id=0f1b0a56&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1b0a56"]])

export default __exports__